import { render, staticRenderFns } from "./eligible_products.vue?vue&type=template&id=0f12ce22&scoped=true&"
import script from "./eligible_products.vue?vue&type=script&lang=js&"
export * from "./eligible_products.vue?vue&type=script&lang=js&"
import style0 from "./eligible_products.vue?vue&type=style&index=0&id=0f12ce22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12ce22",
  null
  
)

export default component.exports